module.exports = __webpack_public_path__ + "img/img3.957826e7.jpg";